import React, { useCallback, useRef, useState } from "react";
import { diffGraph, EMPTY_HISTORY, pushHistory, useEdgesState, useNodesState } from "Custom-Mindmap";
import { getUserInfoFromToken } from '../Utils/helper';
import { MapContext } from './mapContext';

export { MindMapContext } from './mapContext';

export const MindMapContextProvider = ({ children }) => {
  const [documentInfo, setDocumentInfo] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [mindmapInstance, setMindmapInstance] = useState(null);
  const [userInfo, setUserInfo] = useState(() => getUserInfoFromToken() || {});
  const [userColor, setUserColor] = useState('#000');
  const [darkMode, setDarkMode_] = useState(false);
  const [savingData, setSavingData] = useState({
    isSaving: '',
    lastSavedDateTime: "",
    fileSize: 0,
  });
  const [isDocumentChanged, setIsDocumentChanged] = useState(null);
  const mindmapWrapper = useRef(null);
  const [isExternal, setIsExternal] = useState(false);
  const [isExternalAllow, setIsExternalAllow] = useState(false);
  const [isTemplateDocument, setIsTemplateDocument] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Undo/redo (D-036): every local edit records what it changed, as `before` → `after` graphs.
  const [history, setHistory] = useState(EMPTY_HISTORY);
  const recordChange = useCallback(
    (before, after) => setHistory((current) => pushHistory(current, diffGraph(before, after))),
    []
  );
  const clearHistory = useCallback(() => setHistory(EMPTY_HISTORY), []);
  // Copied nodes and edges (D-037): `{ content, pastes }`, kept while the tab is open.
  const [clipboard, setClipboard] = useState(null);

  return (
    <MapContext.Provider
      value={{
        documentInfo,
        isReadOnly,
        nodes,
        edges,
        selectedNodeId,
        mindmapInstance,
        mindmapWrapper,
        userInfo,
        userColor,
        darkMode,
        admins,
        savingData,
        isDocumentChanged,
        isExternal,
        isExternalAllow,
        setDocumentInfo,
        setIsReadOnly,
        setNodes,
        setEdges,
        onEdgesChange,
        onNodesChange,
        setSelectedNodeId,
        setMindmapInstance,
        setUserInfo,
        setUserColor,
        setAdmins,
        setDarkMode_,
        setSavingData,
        setIsDocumentChanged,
        setIsExternal,
        setIsExternalAllow,
        isTemplateDocument, setIsTemplateDocument,
        templateData, setTemplateData,
        isAuthenticated, setIsAuthenticated,
        history, setHistory, recordChange, clearHistory,
        clipboard, setClipboard,
      }}>
      {children}
    </MapContext.Provider>
  );
};

